import { render } from "./MenuSiModuleMain.vue?vue&type=template&id=6a7a6f0a&scoped=true"
import script from "./MenuSiModuleMain.vue?vue&type=script&lang=js"
export * from "./MenuSiModuleMain.vue?vue&type=script&lang=js"

import "./MenuSiModuleMain.vue?vue&type=style&index=0&id=6a7a6f0a&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7a6f0a"]])

export default __exports__